import type { CSSProperties, ReactNode } from "react";

export interface PanelProps {
  title?: ReactNode;
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
  actions?: ReactNode;
}

export function Panel({ title, children, className = "", style, actions }: PanelProps) {
  return (
    <section className={`glass panel fade-in ${className}`} style={style}>
      {title || actions ? (
        <div className="row" style={{ marginBottom: 12 }}>
          {title ? <h2 className="grow" style={{ margin: 0 }}>{title}</h2> : <span className="grow" />}
          {actions}
        </div>
      ) : null}
      {children}
    </section>
  );
}
